var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('p',{staticClass:"bold"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._b({class:_vm.classString,attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }